import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEstopOff = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 22.0004,
	height: 21.9999,
	viewBox: "0 0 22.0004 21.9999",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Vectoring",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Subtract",
			d: "M7.1778 8.17773V16.1836H14.9395L17.5128 18.8379L15.3516 21H7.06256L1.2071 15.1445V6.85547L3.58698 4.47461L7.1778 8.17773ZM15.3516 1L21.2071 6.85547V15.1445L19.6339 16.7168L14.461 11.3799V9.7373H12.8682L10.6964 7.49707H14.92V5.62695H8.88288L5.70905 2.35254L7.06256 1H15.3516ZM13.0987 14.2852H9.3321V11.5703H10.4669L13.0987 14.2852Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Red",
			d: "M0.707096 1.20726L20.7933 21.2928",
			stroke: "currentColor",
			strokeWidth: 2
		})]
	})
});
export default SvgEstopOff;
